module.exports = __webpack_public_path__ + "img/Vector_BG.14e96abc.svg";